export const JobCardSkeleton = () => {
  return (
    <div className='mx-3 mb-2 flex items-center gap-2 rounded border border-grey-10 px-2.5 py-2 shadow-sm'>
      {/* Left side content */}
      <div className='ml-1 flex flex-1 flex-col items-start overflow-hidden'>
        {/* Title skeleton */}
        <div className='mb-1 h-4 w-3/4 animate-pulse rounded bg-gray-200'></div>
        {/* Secondary text skeleton */}
        <div className='h-3 w-1/2 animate-pulse rounded bg-gray-200'></div>
      </div>

      {/* Right side content */}
      <div className='ml-auto flex items-center gap-1'>
        {/* Hero element (time info) */}
        <div className='flex flex-col justify-start pr-1 text-right leading-tight'>
          <div className='mb-1 h-3 w-12 animate-pulse rounded bg-gray-200'></div>
          <div className='h-2 w-16 animate-pulse rounded bg-gray-200'></div>
        </div>

        {/* User avatar and status badge */}
        <div className='flex gap-2'>
          {/* Avatar skeleton */}
          <div className='h-6 w-6 animate-pulse rounded-full bg-gray-200'></div>
          {/* Status badge skeleton */}
          <div className='h-5 w-16 animate-pulse rounded bg-gray-200'></div>
        </div>
      </div>
    </div>
  );
};
